import { Button } from "@/components/ui/button";
import { useRetryFileProcessing } from "@/hooks/use-files";
import { refusalDetail } from "@/services/api-client";
import {
  RETRY_LABEL,
  RETRY_PENDING_LABEL,
  retryActionLabel,
} from "@/lib/file-status";

/**
 * The control on a file the server will take again.
 *
 * One mutation per file rather than one per component: a component can hold
 * several failed files, and a shared mutation would report every one of them
 * working the moment any one was pressed.
 *
 * The refusal the server writes is shown as it is, since it says what is wrong
 * with this file. ``whenRefused`` carries the sentence for a refusal that says
 * nothing, which differs by what the file was going to be used for.
 */
export function RetryAction({
  taskId,
  fileId,
  filename,
  whenRefused,
  onError,
}: {
  taskId: string;
  fileId: string;
  filename: string;
  whenRefused: string;
  onError: (message: string | null) => void;
}) {
  const retry = useRetryFileProcessing(taskId, fileId);

  return (
    <div>
      <Button
        type="button"
        size="dense"
        variant="secondary"
        className="h-7 cursor-pointer text-[11.5px]"
        disabled={retry.isPending}
        aria-label={retryActionLabel(filename)}
        onClick={() => {
          onError(null);
          retry.mutate(undefined, {
            onError: (err) => onError(refusalDetail(err, whenRefused)),
          });
        }}
      >
        {retry.isPending ? RETRY_PENDING_LABEL : RETRY_LABEL}
      </Button>
    </div>
  );
}
